var render = function render(){
  var _vm$fleets$data;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "visible": _vm.isOpen,
      "id": "add-init",
      "size": "xl",
      "title": "ADD REPAIR & MAINTENANCE",
      "header-bg-variant": "light",
      "header-text-variant": "dark",
      "footer-bg-variant": "light",
      "footer-text-variant": "dark",
      "ok-title": "Next"
    },
    on: {
      "hide": function hide($event) {
        return _vm.$emit('close');
      },
      "ok": function ok($event) {
        _vm.fleets.checked ? _vm.emitSelection() : _vm.showAlert;
      }
    }
  }, [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Search fleets..."
    },
    on: {
      "input": _vm.fetchFleets
    },
    model: {
      value: _vm.fleets.params.search,
      callback: function callback($$v) {
        _vm.$set(_vm.fleets.params, "search", $$v);
      },
      expression: "fleets.params.search"
    }
  })], 1)], 1), _vm.fleets.loading ? _c('div', {
    staticClass: "text-center my-5"
  }, [_c('b-spinner', {
    attrs: {
      "type": "grow",
      "label": "Spinning"
    }
  })], 1) : [((_vm$fleets$data = _vm.fleets.data) === null || _vm$fleets$data === void 0 ? void 0 : _vm$fleets$data.length) > 0 ? _c('div', {
    staticStyle: {
      "max-height": "68vh",
      "overflow": "auto"
    }
  }, [_c('b-row', _vm._l(_vm.fleets.data, function (fleet, i) {
    return _c('b-col', {
      key: "fleet-".concat(i),
      staticClass: "text-center py-5 border-top",
      attrs: {
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "custom-control custom-radio image-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.fleets.checked,
        expression: "fleets.checked"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "id": "ck-fl-".concat(i),
        "type": "radio"
      },
      domProps: {
        "value": fleet.id,
        "checked": _vm._q(_vm.fleets.checked, fleet.id)
      },
      on: {
        "change": function change($event) {
          return _vm.$set(_vm.fleets, "checked", fleet.id);
        }
      }
    }), _c('label', {
      staticClass: "custom-control-label",
      attrs: {
        "for": "ck-fl-".concat(i)
      }
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": _vm._f("checkPhoto")(fleet.vehicleType.icon.url, require('@src/assets/images/fleet/PusherBarge.png')),
        "alt": "#"
      }
    })]), _c('small', [_c('strong', [_vm._v(_vm._s(fleet.name))])])])]);
  }), 1)], 1) : _c('div', {
    staticClass: "text-center my-5"
  }, [_c('p', {
    staticClass: "mb-0 text-muted"
  }, [_vm._v("No fleets data found.")])])]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }